const cards = [
  {
    icon: "ri-tools-line",
    title: "Working People",
    text: "Whether you\u2019re in an office, on a job site, or running a business \u2014 AI is already affecting your world. Let\u2019s make sure you\u2019re ready.",
    accent: "bg-amber-100",
    iconColor: "text-amber-700",
  },
  {
    icon: "ri-store-2-line",
    title: "Business Owners",
    text: "Small businesses are using AI to compete with the big guys. Learn how to use it wisely before your competitors do.",
    accent: "bg-amber-100",
    iconColor: "text-amber-700",
  },
  {
    icon: "ri-home-heart-line",
    title: "Parents",
    text: "Your kids are growing up in an AI world. Understanding it isn\u2019t optional anymore \u2014 it\u2019s part of raising informed, prepared children.",
    accent: "bg-amber-100",
    iconColor: "text-amber-700",
  },
  {
    icon: "ri-hand-heart-line",
    title: "People of Faith",
    text: "Technology raises deep human questions. We believe wisdom and integrity should guide how AI is used \u2014 not just profit.",
    accent: "bg-amber-100",
    iconColor: "text-amber-700",
  },
];

export default function WhoItsFor() {
  return (
    <section className="bg-parchment py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        {/* Header */}
        <div className="text-center mb-16">
          <span className="font-sans text-xs font-semibold tracking-widest uppercase text-amber-600 block mb-4">
            Who This Is For
          </span>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-amber-900 mb-5">
            Do You See Yourself Here?
          </h2>
          <p className="font-sans text-base text-stone-500 max-w-xl mx-auto leading-relaxed">
            The Humble Machine is built for people who don&apos;t have a tech background — but know that AI is something they need to understand.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, i) => (
            <div
              key={card.title}
              className="group bg-white rounded-2xl p-8 flex flex-col gap-5 border border-amber-50 hover:border-amber-200 hover:-translate-y-1.5 transition-all duration-300 cursor-default"
            >
              {/* Icon */}
              <div className={`w-14 h-14 flex items-center justify-center rounded-2xl ${card.accent} flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${card.icon} ${card.iconColor} text-2xl`} />
              </div>

              {/* Number + Title */}
              <div>
                <span className="font-sans text-xs font-bold text-amber-400 tracking-widest block mb-2">
                  0{i + 1}
                </span>
                <h3 className="font-serif text-xl font-bold text-amber-900 leading-snug">
                  {card.title}
                </h3>
              </div>

              {/* Divider */}
              <div className="h-px w-10 bg-amber-200 group-hover:w-16 transition-all duration-300" />

              {/* Text */}
              <p className="font-sans text-sm text-stone-500 leading-relaxed flex-1">
                {card.text}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <p className="text-center font-serif italic text-stone-400 text-base mt-12">
          If any of these sound like you &mdash; you&apos;re in the right place.
        </p>
      </div>
    </section>
  );
}
